<template>
  <div class="area-code-selector-wrap">
    <div class="area-code-selector">
      <select class="selector" @change="onAreaCodeChange">
        <option
          v-for="item in areaCode"
          :key="item.name_us"
          :value="item.area_code"
          :selected="+item.area_code === +area"
        >
          {{ item.name_zh }} +{{ item.area_code }}
        </option>
      </select>
      <div class="label">+{{ area }}</div>
      <svg
        t="1620266878749"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="3627"
        width="500"
        height="400"
      >
        <path
          d="M562.5 771c-14.3 14.3-33.7 27.5-52 23.5-18.4 3.1-35.7-11.2-50-23.5L18.8 327.3c-22.4-22.4-22.4-59.2 0-81.6s59.2-22.4 81.6 0L511.5 668l412.1-422.3c22.4-22.4 59.2-22.4 81.6 0s22.4 59.2 0 81.6L562.5 771z"
          p-id="3628"
          fill="#615e6e"
        ></path>
      </svg>
    </div>

    <div v-if="showLine" class="line" />
  </div>
</template>

<script lang="ts">
import { areaCodes } from '@lib/areaCode';

import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
@Component
export default class AreaCodeSelect extends Vue {
  @Prop({ default: true }) public showLine!: boolean;
  @Prop({ default: '86' }) public defaultCode!: string;
  private areaCode = areaCodes;
  private area = '86';

  @Watch('defaultCode', { immediate: true })
  initDefaultCode(newVal: string, oldVal: string) {
    if (newVal !== oldVal) {
      this.area = newVal;
    }
  }

  private onAreaCodeChange(e: any) {
    this.area = e.target.value;
    this.$emit('areaCodeChange', this.area);
  }
}
</script>

<style lang="scss" scoped>
.area-code-selector-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  .area-code-selector {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 156px;
    height: 112px;

    .icon {
      width: 22px;
      height: 22px;
      margin-left: 12px;
    }

    .selector {
      position: absolute;
      box-sizing: content-box;
      width: 100%;
      height: 112px;
      color: #333333;
      font-size: 28px;
      border: none;
      border-radius: 44px 0 0 44px;
      opacity: 0;
    }
    .label {
      color: #615e6e;
      font-size: 32px;
      letter-spacing: 0.65px;
    }
  }

  .line {
    width: 0px;
    height: 60%;
    margin-right: 30px;
    border: 1px solid #dedede;
  }
}
</style>